import { jsxs as x, Fragment as P, jsx as n } from "react/jsx-runtime";
import c, { useRef as I, useEffect as T } from "react";
import { hex2rgb as E, getContrastColor as j, darken as L } from "../../utils/colors.js";
import { SimplyFlowLogo as R } from "../Logos/SimplyFlow.js";
import { Iconify as O } from "../Iconify/index.js";
import { n as H } from "../../emotion-styled.browser.esm-Br5Hs_hj.js";
import { C as B } from "../../CircularLoader-zywd2AbP.js";
import '../../assets/index6.css';var F = /* @__PURE__ */ ((o) => (o.IPHONE = "9/16", o.WIDE = "16/9", o.IPAD = "3/4", o.SQUARE = "1/1", o))(F || {}), M = /* @__PURE__ */ ((o) => (o.bottomRight = "bottomRight", o.bottomLeft = "bottomLeft", o))(M || {});
function V(o) {
  switch (o) {
    case "bottomRight":
      return { transformOrigin: "bottom right" };
    case "bottomLeft":
      return { transformOrigin: "bottom left" };
    default:
      return { transformOrigin: "bottom right" };
  }
}
function K({
  token: o,
  videoPlaybackId: t,
  aspectRatio: r = "9/16",
  position: i = "bottomRight",
  height: a = 250,
  gifFrame: e = 2,
  thumbFrame: u = 2,
  buttonText: d = null,
  buttonColor: m,
  // buttonTextColor,
  buttonLink: b
}) {
  const [l, s] = c.useState(!1), [p, y] = c.useState(!1), [g, C] = c.useState(!1), [h, v] = c.useState(!1), w = `https://image.mux.com/${t}/animated.gif?start=${e}&end=${e + 3}&height=300`, $ = `https://image.mux.com/${t}/thumbnail.png?height=200&time=${u}`, S = V(i), [k] = o.split("_"), z = (f) => {
    f.stopPropagation(), b ? window.location.href = b : window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return /* @__PURE__ */ x(P, { children: [
    /* @__PURE__ */ x(
      "div",
      {
        style: {
          ...W.wrapper,
          aspectRatio: r,
          transform: `scale(${p ? 1.5 : 1})`,
          height: a,
          //hovering ? height * 1.5 : height,
          transformOrigin: S.transformOrigin,
          display: h ? "none" : "inherit"
        },
        role: "button",
        onClick: () => s(!0),
        onMouseEnter: () => y(!0),
        onMouseLeave: () => y(!1),
        children: [
          /* @__PURE__ */ x("div", { style: { position: "relative" }, children: [
            /* @__PURE__ */ n(
              "img",
              {
                src: w,
                alt: "video thumbnail",
                style: {
                  opacity: l && g ? 0 : 1,
                  cursor: "pointer",
                  borderRadius: 8,
                  aspectRatio: r,
                  width: "100%",
                  objectFit: "cover",
                  // width: "100%",
                  verticalAlign: "middle"
                },
                loading: "lazy"
              }
            ),
            d && /* @__PURE__ */ n(
              "div",
              {
                style: {
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  zIndex: 2,
                  padding: "0px 8px 8px",
                  margin: "auto",
                  textAlign: "center"
                },
                children: /* @__PURE__ */ n(
                  _,
                  {
                    customColor: m,
                    variant: "contained",
                    style: { textTransform: "none !important" },
                    onClick: z,
                    children: d
                  }
                )
              }
            ),
            l && /* @__PURE__ */ n(
              D,
              {
                playVideo: l,
                canPlay: g,
                setCanPlay: C,
                minimize: h,
                height: a,
                token: o,
                workspaceId: k,
                videoPlaybackId: t
              }
            ),
            l && !g && /* @__PURE__ */ n(
              "div",
              {
                style: {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                },
                children: /* @__PURE__ */ n(B, {})
              }
            ),
            p && /* @__PURE__ */ n(
              "div",
              {
                style: { position: "absolute", top: 2, right: 4, zIndex: 9999 },
                children: /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n(
                  "div",
                  {
                    role: "button",
                    style: {
                      width: "28px !important",
                      height: "28px !important",
                      backgroundColor: "transparent !important",
                      padding: "24px !important",
                      border: "0px !important",
                      borderRadius: "50% !important",
                      fontSize: "1.125em !important",
                      outline: "none !important"
                    },
                    onClick: (f) => {
                      f.stopPropagation(), v(!0);
                    },
                    children: /* @__PURE__ */ n(O, { icon: "mingcute:minimize-fill", color: "#fff" })
                  }
                ) })
              }
            )
          ] }),
          /* @__PURE__ */ n(
            "div",
            {
              style: {
                position: "absolute",
                top: 8,
                left: 8,
                // right: 0,
                margin: "auto"
              },
              children: /* @__PURE__ */ n(
                "div",
                {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: 4,
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  children: /* @__PURE__ */ n(R, { width: 32, color: "rgba(255,255,255,0.7)" })
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ n(
      "div",
      {
        className: "minimizedPreview",
        style: { display: h ? "block" : "none" },
        onClick: () => v(!1),
        children: /* @__PURE__ */ n(
          "img",
          {
            src: $,
            alt: "video thumbnail",
            style: {
              width: r === "9/16" ? 60 : "100%",
              height: r === "16/9" ? 60 : "100%",
              cursor: "pointer",
              borderRadius: 8,
              aspectRatio: r,
              objectFit: "cover"
            },
            loading: "lazy"
          }
        )
      }
    )
  ] });
}
function D({
  playVideo: o,
  canPlay: t,
  setCanPlay: r,
  minimize: i,
  height: a,
  token: e,
  workspaceId: u,
  videoPlaybackId: d
}) {
  const m = I(null);
  return T(() => {
    const l = m.current;
    if (l) {
      const s = () => {
        r(!0);
      };
      return l.addEventListener("canplay", s), i ? l.pause() : l.play().catch((p) => {
        console.error("Error playing the video:", p);
      }), () => {
        l.removeEventListener("canplay", s);
      };
    }
  }, [r, i]), // @ts-ignore
  /* @__PURE__ */ n(
    "mux-player",
    {
      ref: m,
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        opacity: o && t ? 1 : 0,
        borderRadius: "8px",
        height: a,
        width: "100%",
        // CSS custom properties (variables)
        "--media-object-fit": "cover",
        "--media-background-color": "transparent",
        "--controls": "none"
      },
      class: "mux-player",
      "stream-type": "on-demand",
      "playback-id": d,
      "metadata-video-id": e,
      "metadata-video-title": e,
      "metadata-viewer-user-id": u,
      autoplay: !0
    }
  );
}
const W = {
  wrapper: {
    position: "relative",
    zIndex: 2,
    cursor: "pointer",
    transition: "all .375s",
    width: "100%"
  }
}, _ = H.button((o) => {
  const { customColor: t, flatButton: r } = o;
  if (!t)
    return {
      letterSpacing: "0.02857em !important",
      fontSize: "8px !important",
      fontWeight: "normal !important",
      lineHeight: "1 !important",
      padding: "8px 12px 6px 12px !important",
      textTransform: "none",
      border: "none !important",
      borderRadius: "4px !important",
      color: o.buttonTextColor || void 0,
      boxShadow: "none !important",
      "&:hover": {
        boxShadow: "none !important",
        outline: "none !important"
      }
    };
  const [i, a, e] = E(t);
  return o.variant === "contained" ? {
    letterSpacing: "0.02857em !important",
    fontSize: "8px !important",
    fontWeight: "normal !important",
    lineHeight: "1 !important",
    padding: "8px 12px 6px 12px !important",
    textTransform: "none",
    border: "none !important",
    borderRadius: "4px !important",
    color: `${o.customTextColor || j(t, !0)} !important`,
    backgroundColor: `${t} !important`,
    boxShadow: "none !important",
    //   boxShadow: flatButton ? 'none' : `0 8px 16px 0 rgb(${r} ${g} ${b} / 24%)`,
    "&:hover": {
      boxShadow: "none !important",
      backgroundColor: `${L(t, 0.05)} !important`
    },
    "&:focus": {
      boxShadow: "none !important",
      outline: "none !important",
      backgroundColor: `${t} !important`
    },
    "&:active": {
      boxShadow: "none !important",
      outline: "none !important",
      backgroundColor: `${t} !important`
    }
  } : o.variant === "outlined" ? {
    fontSize: 8,
    lineHeight: 1,
    padding: "8px 12px 6px 12px",
    textTransform: "none",
    color: t,
    borderColor: t,
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
      borderColor: t,
      backgroundColor: r ? "none" : `rgba(${i}, ${a}, ${e}, 0.08)`
    },
    "&:focus": {
      boxShadow: "none",
      borderColor: t,
      backgroundColor: r ? "none" : `rgba(${i}, ${a}, ${e}, 0.08)`
    },
    "&:active": {
      boxShadow: "none",
      borderColor: t,
      backgroundColor: r ? "none" : `rgba(${i}, ${a}, ${e}, 0.08)`
    }
  } : {
    fontSize: 8,
    textTransform: "none",
    color: t,
    // borderColor: customColor,
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
      borderColor: t,
      backgroundColor: r ? "none" : `rgba(${i}, ${a}, ${e}, 0.08)`
    },
    "&:focus": {
      boxShadow: "none",
      borderColor: t,
      backgroundColor: r ? "none" : `rgba(${i}, ${a}, ${e}, 0.08)`
    },
    "&:active": {
      boxShadow: "none",
      borderColor: t,
      backgroundColor: r ? "none" : `rgba(${i}, ${a}, ${e}, 0.08)`
    }
  };
});
export {
  F as AspectRatio,
  K as FloatingVideo,
  M as Position
};
